
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"actualizarAuditoriaInformeObservacionSoloEstatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"observacion"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"inputActualizarAuditoriaInformeObservacionSoloEstatus"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actualizarAuditoriaInformeObservacionSoloEstatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"observacion"},"value":{"kind":"Variable","name":{"kind":"Name","value":"observacion"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idAuditoriaInforme"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idContrato"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numero"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"descripcion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"medidaSolventacion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"montoOriginal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"montoPendiente"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"estatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fechaEstatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"comentarios"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idUsuarioRegistro"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contrato"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numero"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ejercicio"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"detalles"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idAuditoriaObservacion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idContrato"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"requiereAccion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"requiereDocumento"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"texto"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fechaVencimiento"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enviado"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"comentarios"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contrato"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numero"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ejercicio"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":1005}};
    doc.loc.source = {"body":"mutation actualizarAuditoriaInformeObservacionSoloEstatus ($id: ID!, \n$observacion: inputActualizarAuditoriaInformeObservacionSoloEstatus!){\n    actualizarAuditoriaInformeObservacionSoloEstatus(id: $id, observacion: $observacion){\n        id\n        idAuditoriaInforme\n        idContrato\n        numero\n        descripcion\n        medidaSolventacion\n        montoOriginal\n        montoPendiente\n        estatus\n        fechaEstatus\n        comentarios\n        idUsuarioRegistro\n        createdAt\n        updatedAt\n        contrato {\n            id\n            numero\n            ejercicio\n        }\n        detalles {\n            id\n            idAuditoriaObservacion\n            idContrato\n            requiereAccion\n            requiereDocumento\n            texto\n            fechaVencimiento\n            enviado\n            comentarios\n            createdAt\n            updatedAt\n            contrato {\n                id\n                numero\n                ejercicio\n            }\n        }\n    }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["actualizarAuditoriaInformeObservacionSoloEstatus"] = oneQuery(doc, "actualizarAuditoriaInformeObservacionSoloEstatus");
        
